import React from 'react'
import Image from './images/toakbar.png'

const TOAkbar = () => {
  return (
    <div className="w-full bg-blue-200">
      <div className="container p-8 py-20 mx-auto">
        <img src={Image} alt="try-out akbar" className="rounded-xl mx-auto" />
      </div>
    </div>
  )
}

export default TOAkbar
